import styled from "styled-components";

export const StyledDateInputErrorMessage = styled.div`
line-height: 16px;
font-size: 12px;
font-style: normal;
text-align: left;
color: rgb(164, 38, 44);
`;